  import React, { useState, useEffect, useContext } from 'react';
  import { BrowserRouter, Routes, Route} from 'react-router-dom';
  import Home from './components/Home/Home';
  import Header from './components/Header/Header';
  import Footer from './components/Footer/Footer';
  import Login from './components/Landing Page/Login';
  import { Toaster } from 'react-hot-toast';
  import 'react-toastify/dist/ReactToastify.css';
  import axios from 'axios';
  import { Context1 } from './utils/auth';
  import Category from './components/Category/Category';
  import SingleProduct from './components/SingleProduct/SingleProduct';
  import AppContext1 from './utils/context';
  import Shop from './components/Shop/Shop';
  import Review from './components/Review/Review';
  import Checkout from './components/Checkout/Checkout';
  import OrderSuccess from './components/OrderSuccess/OrderSuccess';

  function App() {

    const { user, gAuth, setGAuth} = useContext(Context1);

    const [userImg, setUserImg] = useState('');
    const [userEmail, setUserEmail] = useState('');
    const [userName, setUserName] = useState('');

    const getUser = async () => {
      try {
        const url = `${process.env.REACT_APP_API}/auth/login/success`;
        console.log("Success")
        const { data } = await axios?.get(url, { withCredentials: true });
        setUserImg(data?.user?._json?.picture);
        setUserEmail(data.user._json.email);
        setUserName(data.user._json.name);
        setGAuth(true);
      } catch (err) {
        console.log(err);
        console.log("Failed")
      }
    };

    useEffect(() => {
      getUser();
    }, []);

    return (
      <BrowserRouter>
        <Toaster />
        <AppContext1>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={(user || gAuth) ? <><Header img={userImg} userName={userName} userEmail={userEmail} /><Home /><Footer /></> : <Login />} />
            <Route path="/shop" element={<><Header img={userImg} userName={userName} userEmail={userEmail} /><Shop /><Footer /></>} />
            <Route path="/category/:id" element={<><Header img={userImg} userName={userName} userEmail={userEmail} /><Category /><Footer /></>} />
            <Route path="/product/:id" element={<><Header img={userImg} userName={userName} userEmail={userEmail} /><SingleProduct /><Footer /></>} />
            <Route path="/review" element={<><Review /></>} />
            <Route path="/checkout" element={<><Checkout /></>} />
            <Route path="/paymentsuccess" element={<><OrderSuccess /></>} />
          </Routes>
        </AppContext1>
      </BrowserRouter>
    );
  }

  export default App;
